module.exports = "/assets/data/d6cea7e93dac32f6a855742def79bfb8-DN22.data.json";